import {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import { UseRequest } from "../../hooks/UseRequest";

import Loading from "../../modules/generic/Loading";
import Workflow from "../../modules/workflow/Workflow";

import UseSetterNodeError from "../../modules/workflow/hooks/UseSetterNodeError";


/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const Builder = (props) => {

    const {id} = useParams()
    const [entity, setEntity] = useState(null)
    const [loading, setLoading] = useState(true)


    useEffect(() => {
        {id && fetchJourney().then((response) => {
            setEntity(response)
            setLoading(false)
        })}

        document.getElementsByTagName('body')[0].classList.add('has-editor')

        const handleBeforeUnload = () => {
            document.getElementsByTagName('body')[0].classList.remove('has-editor')
        };


        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
            handleBeforeUnload();
        };

    }, [])


    /**
     *
     * @returns {Promise<*|null>}
     */
    const fetchJourney = async () => {
        const askForJourney = UseRequest(
            `${process.env.REACT_APP_BASE_API}/journeys/get`, {
                request: {
                    method: 'PUT',
                    data: {limit: 1, offset: 0, _id: id}
                }
            }
        );

        const response = await (await askForJourney).json();
        return response && response.total > 0 ? response.entities[0] : null
    }


    /**
     * @param response
     * @param nodes
     * @param edges
     * @returns {unknown}
     */
    const getStatedNodes = (response, nodes, edges) => {
        const newEntity = {...entity};

        if(nodes && nodes.length > 0){
            nodes.map((node) => {
                if(response.errors && response.errors[node.id]){
                    Object.keys(response.errors[node.id]).map((key) => {
                        node.data.hasErrors = true;
                        const keyparts = key.split('.')
                        node = UseSetterNodeError(node, keyparts[0], keyparts[1], response.errors[node.id][key])
                    })

                }else{
                    delete node.data.hasErrors
                }
            })
        }



        return newEntity;
    }

    /**
     * @param nodes
     * @param edges
     * @returns {Promise<void>}
     */
    const handleSave = async ({nodes, edges}) => {
        const tryToSave = UseRequest(`${process.env.REACT_APP_BASE_API}/journeys/upsert/${id}`, {
            request: {
                method: 'POST', data: {
                    info: {
                        title: entity.title,
                        status: entity.status,
                        description: entity.description,
                        id_audience: entity.id_audience.$oid,
                    },
                    workflow: {
                        nodes: nodes,
                        edges: edges
                    }
                }
            }
        })

        const response = await (await tryToSave).json()
        setEntity(getStatedNodes(response, nodes, edges))
    }



    const WorkflowOptions = {
        journey: entity,
        route: props.route,
        onSave: handleSave,
        initialNodes: entity && entity.workflow && entity.workflow.nodes,
        initialEdges: entity && entity.workflow && entity.workflow.edges,
    }



    return (
        <div className="JourneyBuilder">
            {loading && <Loading/>}
            {!loading && <Workflow {...WorkflowOptions} />}
        </div>
    )
}

export default Builder;